<div class="page404-container">
  <div class="stars"></div>
  
  <div class="error-content">
    <div class="glitch-wrapper">
      <h1 class="glitch" data-text="404">404</h1>
    </div>
    
    <div class="error-message">
      <h2 class="fade-in">Ups! Strona nie została znaleziona</h2>
      
      <p class="fade-in-delay" *ngIf="suggestions.length === 0">
        Strona, której szukasz, nie istnieje lub została przeniesiona.
      </p>
      
      <p class="fade-in-delay" *ngIf="suggestions.length > 0">
        Nie znaleźliśmy tej strony, ale może chodziło Ci o jedną z poniższych?
      </p>
      
      <!-- Similar routes suggestions -->
      <div class="suggestions" *ngIf="suggestions.length > 0">
        <ul class="suggestions-list">
          <li *ngFor="let suggestion of suggestions" class="suggestion-item">
            <a (click)="navigateToSuggestion(suggestion.path)" class="suggestion-link">
              <span class="suggestion-path">{{ suggestion.path }}</span>
              <span class="suggestion-similarity">{{ suggestion.similarity | number:'1.0-0' }}% podobieństwa</span>
            </a>
          </li>
        </ul>
      </div>
    </div>
    
    <div class="button-container">
      <a routerLink="/" class="home-button">
        <span class="button-text">Wróć do strony głównej</span>
        <span class="button-icon">→</span>
      </a>
    </div>
  </div>
  
  <div class="floating-shapes">
    <div class="shape shape1"></div>
    <div class="shape shape2"></div>
    <div class="shape shape3"></div>
  </div>
</div>
